import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Tag, BarChart3 } from 'lucide-react';
import CustomizationCard from './CustomizationCard';

interface CustomizationOption {
  title: string;
  type: string;
  description: string;
  icon: React.ReactNode;
  color: string;
}

const CustomizationContainer: React.FC = () => {
  const userPrefs = useSelector(
    (state: any) => state?.rootReducers?.user?.userPreferences || {}
  );

  // Only Labels and Status for now
  const customizationOptions: CustomizationOption[] = useMemo(() => [
    {
      title: 'Lead Labels',
      type: 'labels',
      description: 'Create custom labels for organizing leads',
      icon: <Tag size={22} />,
      color: '#3b82f6'
    },
    {
      title: 'Lead Status',
      type: 'status',
      description: 'Customize stages in your sales pipeline',
      icon: <BarChart3 size={22} />,
      color: '#10b981'
    }
  ], []);

  return (
    <div style={{
      padding: '28px 32px',
      backgroundColor: '#f8fafc',
      minHeight: '100%'
    }}>
      <div style={{
        maxWidth: '900px',
        margin: '0 auto'
      }}>
      {/* Header */}
      <div style={{ marginBottom: '24px' }}>
        <h1 style={{
          margin: '0 0 6px 0',
          fontSize: '24px',
          fontWeight: '700',
          color: '#111827'
        }}>
          Customization
        </h1>
        <p style={{
          margin: 0,
          fontSize: '14px',
          color: '#6b7280'
        }}>
          Customize your CRM for your needs
        </p>
      </div>

      {/* Stats Row */}
      <div style={{
        display: 'flex',
        gap: '16px',
        marginBottom: '24px'
      }}>
        {customizationOptions.map((option) => {
          const count = userPrefs[option.type]?.length || 0;
          return (
            <div key={option.type} style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              padding: '12px 18px',
              backgroundColor: '#fff',
              border: `1px solid ${option.color}30`,
              borderRadius: '10px',
              boxShadow: '0 1px 2px rgba(0,0,0,0.04)'
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '36px',
                height: '36px',
                backgroundColor: `${option.color}12`,
                borderRadius: '8px',
                color: option.color
              }}>
                {option.icon}
              </div>
              <div>
                <div style={{ fontSize: '12px', color: '#6b7280', lineHeight: 1.2 }}>
                  {option.title}
                </div>
                <div style={{ fontSize: '18px', fontWeight: '700', color: '#111827' }}>
                  {count}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Customization Cards */}
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px'
      }}>
        {customizationOptions.map((option) => (
          <CustomizationCard
            key={option.type}
            title={option.title}
            type={option.type}
            description={option.description}
            icon={option.icon}
            color={option.color}
          />
        ))}
      </div>
      </div>
    </div>
  );
};

export default CustomizationContainer;
